import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight, Ship } from "lucide-react";
import { Reveal } from "./Reveal";
import { openGradeFinder } from "./GradeFinder";
import { useLang, usePath } from "../i18n";

export const KeyNumbers = () => {
  const { t } = useLang();
  return (
    <section data-testid="key-numbers" className="bg-clara-cream border-y border-clara-espresso/10 py-14">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <p className="eyebrow text-clara-terracotta mb-8">{t.numbers.eyebrow}</p>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-10">
          {t.numbers.items.map(([n, l], i) => (
            <Reveal key={l} delay={i * 0.08}>
              <div className="font-display font-light text-5xl lg:text-6xl tracking-tighter text-clara-espresso" data-testid={`key-number-${i}`}>{n}</div>
              <div className="font-data text-[10px] tracking-[0.18em] uppercase text-clara-muted mt-2">{l}</div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export const FinderEntry = () => {
  const { t } = useLang();
  const F = t.finder;
  return (
    <section data-testid="finder-entry" className="bg-clara-cream text-clara-espresso border-t border-clara-espresso/10 py-20">
      <div className="relative z-10 max-w-[1400px] mx-auto px-6 lg:px-10 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">
        <div>
          <p className="eyebrow text-clara-terracotta mb-4">{F.eyebrow}</p>
          <h2 className="font-display font-light text-4xl lg:text-5xl tracking-tighter max-w-xl">{F.title}</h2>
        </div>
        <button onClick={openGradeFinder} data-testid="finder-open-btn" className="inline-flex items-center gap-2 rounded-full bg-clara-terracotta px-8 py-4 text-sm font-semibold text-clara-cream hover:bg-clara-espresso transition-colors duration-300 shrink-0">
          {F.cta} <ArrowRight className="w-4 h-4" />
        </button>
      </div>
    </section>
  );
};

export const ExportBlock = () => {
  const { t } = useLang();
  const lp = usePath();
  const E = t.exportBlock;
  return (
    <section data-testid="export-block" className="bg-clara-cream py-24">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-4">
          <Ship className="w-10 h-10 text-clara-terracotta" strokeWidth={1.25} />
        </div>
        <div className="lg:col-span-5">
          <p className="eyebrow text-clara-terracotta mb-4">{E.eyebrow}</p>
          <h2 className="font-display font-light text-4xl lg:text-5xl tracking-tighter text-clara-espresso mb-5">{E.title}</h2>
          <p className="text-clara-muted leading-relaxed">{E.body}</p>
        </div>
        <div className="lg:col-span-3 lg:text-right">
          <Link to={lp("/quality")} data-testid="export-block-cta" className="inline-flex items-center gap-2 rounded-full bg-clara-espresso px-8 py-4 text-sm font-semibold text-clara-cream hover:bg-clara-terracotta transition-colors duration-300">
            {E.cta} <ArrowUpRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
};
